/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banner_Dimensions_HintInputs */



/**
* | output |
* | --- |
* | "Recommended 1200 × 630 (1.91:1). Keep key art inside the dashed safe zone." |
*
* @param {Banner_Dimensions_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const banner_dimensions_hint = /** @type {((inputs?: Banner_Dimensions_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banner_Dimensions_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recommandé 1200 × 630 (1.91:1). Gardez l'illustration principale dans la zone de sécurité délimitée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recomendado 1200 × 630 (1.91:1). Mantenga el arte principal dentro de la zona segura delimitada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recomendado 1200 × 630 (1.91:1). Mantenha a arte principal dentro da zona segura delimitada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Consigliato 1200 × 630 (1.91:1). Mantenere l'immagine principale all'interno dell'area sicura delimitata.")
	return /** @type {LocalizedString} */ ("Recommended 1200 × 630 (1.91:1). Keep key art inside the dashed safe zone.")
});